export default __webpack_public_path__ + "static/media/dashboard_logo.64681efd.svg";